import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Table, Header, Button } from 'semantic-ui-react'
import {firebaseAuth, pythonApiIp, logComponentLoad, cleanPhoneRemovePlus256 } from '../../../../config/constants'
import * as UiConsts from '../../../../config/UiConstants';
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import AckMessage from './AckMessage';

class ViewSmsFromPhone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            assessments: [],
            vat_refund_total:'',
            approved: false,
            smses:[]
        }
    }

    componentDidMount() {
        console.log("gsmsph1 ++++++++++ ViewSmsFromPhone componentDidMount");
  

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("gsmsph121 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("gsmsph122 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("gsmsph123 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)


                }
            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

        
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ gsmsph14 setAdminResult");

        logComponentLoad(returnObject, "ViewSmsFromPhone");

        if (returnObject.algoliaUser && returnObject.algoliaUser.perms.includes("viewSmsFromPhone")) {
            this.getSmsMessageFromPhone();
            this.setState({
                algoliaUser: returnObject.algoliaUser,
                approved: true
            })
        } else {
            console.log("gsmsph15 user not approved")
        }

    }


    getSmsMessageFromPhone = () => {
        console.log("gsmsph13 ++++++++:getSmsMessageFromPhone");
        console.log("gsmsph14 this.state.user.email:"+this.state.user.email);

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getSmsMessageFromPhone', {
            apiKey: "asdfasdf",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log("gsmsph141:"+JSON.stringify(response.data,null,3));

                if (response.data.result) {
                    console.log("gsmsph142: smses:" + JSON.stringify(response.data.smses, null, 3))
                    this.setState({
                        smses: response.data.smses
                    })

                } else {
                    console.log("gsmsph143 FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    render() {

        const rows = this.state.user && this.state.smses.length > 0
            ? this.state.smses.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.idsmsmessagefromphones} </Table.Cell>
                    <Table.Cell><Header as='h3' textAlign='center'>{item.message} </Header> </Table.Cell>
                    <Table.Cell><Header as='h3' textAlign='center'>{cleanPhoneRemovePlus256(item.sender)} </Header> </Table.Cell>
                    <Table.Cell><Link to={'/dashboard/connectedOrders/'+cleanPhoneRemovePlus256(item.sender)} target="_blank">VIEW ORDERS</Link> </Table.Cell>
                    <Table.Cell> {item.phonefromname} </Table.Cell>
                    <Table.Cell> <AckMessage messageId = {item.idsmsmessagefromphones} user={this.state.user} message={item} getSmsMessageFromPhone={this.getSmsMessageFromPhone}/> </Table.Cell>
                    <Table.Cell> {item.deviceid} </Table.Cell>
                    <Table.Cell> {item.messageuid} </Table.Cell>
                    <Table.Cell> {item.timestampmilli} </Table.Cell>
                    <Table.Cell> {item.datetimesent} </Table.Cell>
                    <Table.Cell> {item.acknowledged} </Table.Cell>
                    <Table.Cell> {item.acknowledgedby} </Table.Cell>
                </Table.Row>)
            : ''


        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <h2>SMS FROM PHONE</h2>

                <Button color='red' onClick={this.getSmsMessageFromPhone}> REFRESH</Button>

                {/* <h3> TOTAL COST:{toCurrency(this.state.totalCost)}</h3> */}
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                        <Table.Cell>Sms Id</Table.Cell>
                            <Table.Cell>message</Table.Cell>
                            <Table.Cell>sender</Table.Cell>
                            <Table.Cell>VIEW ORDERS</Table.Cell>
                            <Table.Cell>phonefromname</Table.Cell>
                            <Table.Cell>Acknowledge</Table.Cell>
                            <Table.Cell>deviceid</Table.Cell>
                            <Table.Cell>messageuid</Table.Cell>
                            <Table.Cell>timestampmilli</Table.Cell>
                            <Table.Cell>datetimesent</Table.Cell>
                            <Table.Cell>acknowledged</Table.Cell>
                            <Table.Cell>acknowledgedby</Table.Cell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {rows}
                    </Table.Body>

                </Table>

            </div>
        );
    }
}

export default ViewSmsFromPhone;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/SmsFromPhone/ViewSmsFromPhone.js